import React from 'react';
import { StyledDrawer, DrawerContent } from './index.styles';
import ManageSubscriptionNav from './ManageSubscriptionNav';
import type { ProductPlan, CurrentSubscriptionPlan, OrderedPlan } from '../../types';

export interface ManageSubscriptionDrawerProps {
  isShowing: boolean;
  toggleDrawer: () => void;
  isInCoolingOffPeriod: boolean;
  returnFocus?: (suggestedNode: Element) => boolean;
  currentSubscription: CurrentSubscriptionPlan;
  onSelectPlan: (plan: OrderedPlan) => Promise<void>;
  allProducts: ProductPlan[];
  canChangeSubscription: boolean;
  billingDateToday: boolean;
  hasDeferment: boolean;
}

const ManageSubscriptionDrawer: React.FC<ManageSubscriptionDrawerProps> = ({
  isShowing,
  toggleDrawer,
  isInCoolingOffPeriod,
  returnFocus,
  currentSubscription,
  onSelectPlan,
  allProducts,
  canChangeSubscription,
  billingDateToday,
  hasDeferment,
}) => (
  <StyledDrawer
    isShowing={isShowing}
    toggleHide={toggleDrawer}
    zIndex={10}
    disableClickOutside={false}
    returnFocus={returnFocus}
  >
    <DrawerContent>
      <ManageSubscriptionNav
        isInCoolingOffPeriod={isInCoolingOffPeriod}
        currentSubscription={currentSubscription}
        onSelectPlan={onSelectPlan}
        toggleDrawer={toggleDrawer}
        allProducts={allProducts}
        canChangeSubscription={canChangeSubscription}
        billingDateToday={billingDateToday}
        hasDeferment={hasDeferment}
      />
    </DrawerContent>
  </StyledDrawer>
);

export default ManageSubscriptionDrawer;
